import { Component, OnInit } from '@angular/core';
import { User } from '../../_models/user';
import { MatDialog } from '@angular/material/dialog';
import { ModalAvisosNfComponent } from '../modal-avisos-nf/modal-avisos-nf.component';


@Component({
    selector: 'app-home',
    templateUrl: 'home.component.html'
})

export class HomeComponent implements OnInit {
    currentUser: User;
    currentDate: string;

    dayname = new Array("Domingo", "Segunda-feira", "Terça-feira", "Quarta-Feira", "Quinta-feira", "Sexta-feira", "Sábado");
    monName = new Array("janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto","setembro", "outubro", "novembro", "dezembro");

    constructor(private dialog?: MatDialog) {
        let dateNow = new Date();
        this.currentDate = `${this.dayname[dateNow.getDay()]}, ${dateNow.getDate()} de ${this.monName[dateNow.getMonth()]} de ${dateNow.getFullYear ()}.`;
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));



    }

    ngOnInit() {
        this.showModalOncePerDay();
    }
    showModalOncePerDay() {
        const lastModalDisplayDate = localStorage.getItem('lastModalDisplayDate');
        const today = new Date().toDateString();
    
        if (!lastModalDisplayDate || lastModalDisplayDate !== today) {
          this.dialog.open(ModalAvisosNfComponent, {
            panelClass: 'modalAvisos'
            });
    
          localStorage.setItem('lastModalDisplayDate', today);
        }
      }
}
